$(document).ready(function() {
// Swiper: Slider
    new Swiper('.swiper-container', {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
            1920: {
                slidesPerView: 6,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 6,
                spaceBetween: 30
            },
            990: {
                slidesPerView:4 ,
                spaceBetween: 10
            }
        }
    });
});
